import Script from "next/script";
import { useEffect, useRef } from "react";
import { useIubendaPreferences } from "~/features/app/scripts/iubenda";
import { requestConsentReload } from "~/features/app/scripts/iubenda/controller";
const WARM_CLIENT_ID = process.env.NEXT_PUBLIC_WARMLY_CLIENT_ID;
export function WarmlyScript() {
  const preferences = useIubendaPreferences();
  const wasAllowed = useRef(false);
  useEffect(() => {
    if (!WARM_CLIENT_ID) return;
    if (wasAllowed.current && !preferences.marketing) requestConsentReload();
    wasAllowed.current = preferences.marketing;
  }, [preferences.marketing]);

  // Warmly de-anonymises visitors for sales outreach, so it is a MARKETING
  // purpose, not measurement. Gating it on `measurement` let it load for US
  // visitors who had opted out of "sharing" but not "sale".
  if (!WARM_CLIENT_ID || !preferences.marketing) {
    return null;
  }
  return <Script id="warmly-script-loader" strategy="afterInteractive" src={`https://opps-widget.getwarmly.com/warmly.js?clientId=${WARM_CLIENT_ID}`} />;
}